import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import Button from "@mui/material/Button";
import {
  SysMessageLevel,
  SysMessageWithLevel,
} from "../../contexts/sys_messages/type";

const levelToColor = (level: SysMessageLevel): AlertProps["severity"] => {
  switch (level) {
    case "NEUTRAL":
      return "info";
    case "EMPHASIZED":
      return "info";
    case "WARNING":
      return "warning";
    case "DANGER":
      return "error";
    case "SUCCESS":
      return "success";
    default:
      return "info";
  }
};

export const SystemMessagesComponent = (props: {
  systemMessages: SysMessageWithLevel[];
  removeSystemMessage: (i: number) => void;
}) => {
  const { systemMessages, removeSystemMessage } = props;

  return (
    <>
      {systemMessages.map((m, i) => (
        <Snackbar
          key={i}
          open={true}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          onClose={() => removeSystemMessage(i)}
          autoHideDuration={m.keepOpen ? null : 6000} // Optional: Adjust as needed
        >
          <MuiAlert
            severity={levelToColor(m.level)} // Valid AlertColor value
            action={
              <Button
                size="small"
                onClick={() => removeSystemMessage(i)}
                color="inherit"
              >
                Dismiss
              </Button>
            }
          >
            {m.message}
          </MuiAlert>
        </Snackbar>
      ))}
    </>
  );
};
